import { ServicesOverview } from '../components/ServicesOverview';
import { useNavigate } from 'react-router-dom';

export function ServicesPage() {
  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigateToService = (servicePath: string) => {
    navigate(servicePath);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigateToPathway = (pathwayPath: string) => {
    navigate(pathwayPath);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <ServicesOverview 
      onNavigateHome={handleNavigateHome}
      onNavigateToSchoolSupport={() => handleNavigateToService('/services/school-family-support')}
      onNavigateToLegalSupport={() => handleNavigateToService('/services/legal-support')}
      onNavigateToRealEstate={() => handleNavigateToService('/services/real-estate')}
      onNavigateToHomeManagement={() => handleNavigateToService('/services/home-management')}
      onNavigateToSpiritualWellness={() => handleNavigateToService('/services/spiritual-wellness')}
      onNavigateToBusinessConsulting={() => handleNavigateToService('/services/business-consulting')}
      onNavigateToBeverageDevelopment={() => handleNavigateToService('/services/beverage-development')}
      onNavigateToEliteConcierge={() => handleNavigateToService('/services/elite-concierge')}
      onNavigateToForFamilies={() => handleNavigateToPathway('/pathways/families')}
      onNavigateToForEntrepreneurs={() => handleNavigateToPathway('/pathways/entrepreneurs')}
      onNavigateToForHighNetWorth={() => handleNavigateToPathway('/pathways/high-net-worth')}
    />
  );
}
